{
  "concept": [
    "F33",
    "Q38"
  ],
  "note": "Fabis Namen aus docs/namen.md. special: nur für Spezies mit allen genannten Merkmalen (nameTags in species.json): cute = niedlich (klein, Fell oder Federn), small = klein, fur = Fell, cunning = gilt als gerissen.",
  "names": [
    "Taavi",
    "Joen",
    "Silas",
    "Silvan",
    "Silvester",
    "Silvana",
    "Forrest",
    "Tallis",
    "Avid",
    "Hagen",
    "Embla",
    "Ivo",
    "Yves",
    "Björk",
    "Linnea",
    "Linn",
    "Hazel",
    "Pinja",
    "Erika",
    "Sieglinde",
    "Gerlinde",
    "Björn",
    "Bernd",
    "Ursel",
    "Ulf",
    "Wolfram",
    "Ylva",
    "Eberhard",
    "Robin",
    "Ronja",
    "Mattis",
    "Laurin",
    "Alwin",
    "Alva",
    "Vidar",
    "Holda",
    "Veit",
    "Eike",
    "Linda",
    "Tilia",
    "Amelie",
    "Olivia",
    "Ilva",
    "Yvo",
    "Flora",
    "Yara",
    "Lutz",
    "Schratz",
    "Polina",
    "Frodo"
  ],
  "special": [
    {
      "name": "Fussel",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Krümel",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Flocke",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Flöckchen",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Filou",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Eichelchen",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Moosbeerchen",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Bär",
      "needs": [
        "cute"
      ]
    },
    {
      "name": "Fellfreund",
      "needs": [
        "cute",
        "fur"
      ]
    },
    {
      "name": "Lützel",
      "needs": [
        "small"
      ]
    },
    {
      "name": "Schalk",
      "needs": [
        "cunning"
      ]
    },
    {
      "name": "Lia",
      "needs": [
        "graceful"
      ]
    },
    {
      "name": "Waldemar",
      "needs": [
        "stocky"
      ]
    }
  ]
}
